module.exports = __webpack_public_path__ + "static/media/dr-virajinee.6a6d1356.jpg";